/**
 * OrbDocTutorialsAdvancedAiGenerationENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsAdvancedAiGenerationENDocScreen
 */

import { useOrbDocTutorialsAdvancedAiGenerationENDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsAdvancedAiGenerationENDocScreenLogic';
import type { OrbDocTutorialsAdvancedAiGenerationENDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsAdvancedAiGenerationENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsAdvancedAiGenerationENDocView as OrbDocTutorialsAdvancedAiGenerationENDocViewEntity } from '@app/shared';
import { OrbDocTutorialsAdvancedAiGenerationENDocBodyView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationENDocBodyView';
import { OrbDocTutorialsAdvancedAiGenerationENDocFooterView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationENDocFooterView';
import { OrbDocTutorialsAdvancedAiGenerationENDocHeaderView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsAdvancedAiGenerationENDocScreenViewProps {
  config?: Partial<OrbDocTutorialsAdvancedAiGenerationENDocScreenConfig>;
}

export function OrbDocTutorialsAdvancedAiGenerationENDocScreenView({ config: propsConfig }: OrbDocTutorialsAdvancedAiGenerationENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsAdvancedAiGenerationENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsAdvancedAiGenerationENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsAdvancedAiGenerationEN" trait="OrbDocTutorialsAdvancedAiGenerationENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsAdvancedAiGenerationENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsAdvancedAiGenerationENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsAdvancedAiGenerationENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsAdvancedAiGenerationENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsAdvancedAiGenerationENDocScreenView;
